import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Grid, Typography } from "@material-ui/core";

import { MonetaryAmount } from "../../../../domain/monetary-amount";
import { translate } from "../../../../../infrastructure/translate/localization";
import { acceptEducation } from "../../../../../usecases/requests/accept-education";
import { hideModal } from "../../../../../usecases/commons/hide-modal";

import Modal from "../../Modal";
import CobeeButton from "../../../CobeeButton";
import CobeeTextField from "../../../CobeeTextField";

import useStyles from "./styles";

export default function ApproveRequestHHRR({
  requestId,
  amount,
  educationBags,
}) {
  const { buttonsContainer, textCurrency } = useStyles();
  const [companyAmount, setCompanyAmount] = useState(0);
  const [paidEmployeeFlex, setPaidEmployeeFlex] = useState(amount);
  const [fetching, setFetch] = useState(false);
  const [bagAmount, setBagAmount] = useState(MonetaryAmount.ZERO);

  useEffect(() => {
    if (educationBags?.length > 0) {
      let limitAmount = MonetaryAmount.ZERO;
      let usedAmount = MonetaryAmount.ZERO;

      educationBags.forEach((bag) => {
        limitAmount = limitAmount.add(bag.limitAmount);
        usedAmount = usedAmount.add(bag.usedAmount);
      });

      setBagAmount(MonetaryAmount.ofCurrency(limitAmount.subtract(usedAmount)));
    }
  }, [educationBags, setBagAmount]);

  const handleInputChange = (value) => {
    setCompanyAmount(value === "" ? "" : Number(value));
    setPaidEmployeeFlex(amount - Number(value));
  };

  const handleBlur = () => {
    if (companyAmount < 0 || companyAmount === "") {
      setCompanyAmount(0);
      setPaidEmployeeFlex(amount);
    }
  };

  const handlerApprove = async () => {
    setFetch(true);
    await acceptEducation({
      requestId,
      centsInPayroll: amount * 100,
      centsAmountFromFunds: companyAmount * 100,
    });
    setFetch(false);
  };

  return (
    <Modal title={translate("request-section.approve-hhrr-extended")}>
      <Grid container spacing={3} direction="column">
        <Grid item>
          <Typography variant="body2">
            {`${translate(
              "request-section.total-amount-of-the-course"
            )}: ${MonetaryAmount.fromUnitary(amount).prettifyMoney({})}`}
          </Typography>
        </Grid>

        {educationBags.length > 0 && (
          <Grid item>
            <Typography variant="body2">
              {translate("request-section.amount-paid-by-employee-message")}:{" "}
              {bagAmount?.prettifyMoney({})}
            </Typography>
          </Grid>
        )}

        {amount > bagAmount.amountInCents / 100 && (
          <>
            <Grid item>
              <Typography variant="body2">
                {`${translate(
                  "request-section.choose-payment-method-message"
                )}: ${MonetaryAmount.fromUnitary(amount)
                  .subtract(bagAmount)
                  .prettifyMoney({})}`}
              </Typography>
            </Grid>

            <Grid item>
              <Grid>
                <Typography variant="body2">
                  {`${translate("request-section.amount-to-be-paid-company")}:`}
                </Typography>
              </Grid>
              <Grid container direction="row" alignItems="center">
                <CobeeTextField
                  type="number"
                  onBlur={handleBlur}
                  minWidth={118}
                  onChange={(e) => handleInputChange(e.target.value)}
                  value={companyAmount}
                />
                <Typography className={textCurrency}>EUR</Typography>
              </Grid>
            </Grid>

            <Grid item>
              <Typography variant="body2">
                {`${translate(
                  "request-section.amount-to-be-paid-employee-flex"
                )}: ${MonetaryAmount.fromUnitary(
                  paidEmployeeFlex
                ).prettifyMoney({})}`}
              </Typography>
            </Grid>
          </>
        )}
        <Grid
          container
          spacing={2}
          justify="center"
          className={buttonsContainer}
        >
          <Grid item>
            <CobeeButton styleType="secondary" onClick={hideModal}>
              {translate("actions.cancel")}
            </CobeeButton>
          </Grid>
          <Grid item>
            <CobeeButton onClick={handlerApprove} isLoading={fetching}>
              {translate("actions.approve-request")}
            </CobeeButton>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
}

ApproveRequestHHRR.defaultProps = {
  educationBags: {},
};

ApproveRequestHHRR.propTypes = {
  requestId: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  educationBags: PropTypes.array,
};
